import { render, staticRenderFns } from "./addserver.vue?vue&type=template&id=a2a497c6&scoped=true&"
import script from "./addserver.vue?vue&type=script&lang=js&"
export * from "./addserver.vue?vue&type=script&lang=js&"
import style0 from "./addserver.vue?vue&type=style&index=0&id=a2a497c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a497c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2a497c6')) {
      api.createRecord('a2a497c6', component.options)
    } else {
      api.reload('a2a497c6', component.options)
    }
    module.hot.accept("./addserver.vue?vue&type=template&id=a2a497c6&scoped=true&", function () {
      api.rerender('a2a497c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/serverManagement/components/addserver.vue"
export default component.exports